<template>
  <view class="flights-type">
    <view
      wx:for="{{tabs}}"
      wx:key="item.key"
      class="flights-type-item"
      wx:class="{{item.key === actived ? 'active' : ''}}"
      bindtap="onTabTap(item)"
    ><text class="text">{{item.text}}</text></view>
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({
    properties: {
      tabs: {
        type: Array,
        value: () => ([])
      },
      actived: {
        type: Number,
        value: 0
      }
    },
    methods: {
      onTabTap(item) {
        this.triggerEvent('tabTap', item)
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .flights-type
    height 46px
    padding-top 6px
    @extend .flex-center
    justify-content space-between
    &-item
      flex 1
      text-align center
      color #666
      font-size 14px
      line-height 50px
      position relative
      .text
        position relative
        z-index 1
      &.active
        color #222
        font-weight 600
        &::after
          content ''
          position absolute
          display block
          width 28px
          height 4px
          left 50%
          bottom 16px
          transform translateX(-50%)
          background-color #FF6400
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
    }
  }
</script>
